
import { useState, useMemo } from 'react';
import { FilterCategory } from '../types';
import { createFilterCategories, filterDevicesByCategories } from '../filterUtils';

/**
 * Hook for managing device map filters
 */
export const useMapFilters = (deviceType: string, allDevices: any[]) => {
  const [activeFilters, setActiveFilters] = useState<Record<string, string[]>>({});
  
  // Generate filter categories
  const filterCategories = useMemo(() => 
    createFilterCategories(deviceType),
  [deviceType]);
  
  // Apply filters to devices
  const filteredDevices = useMemo(() => 
    filterDevicesByCategories(allDevices, activeFilters),
  [allDevices, activeFilters]);
  
  // Handle filter changes
  const handleFilterChange = (category: string, value: string) => {
    setActiveFilters(prev => {
      // Create a new object to avoid mutating the state directly
      const newFilters = { ...prev };
      
      // If this category doesn't exist yet, initialize it
      if (!newFilters[category]) {
        newFilters[category] = [];
      }
      
      // Toggle the value
      if (newFilters[category].includes(value)) {
        newFilters[category] = newFilters[category].filter(v => v !== value);
      } else {
        newFilters[category].push(value);
      }
      
      // If the category is empty, remove it
      if (newFilters[category].length === 0) {
        delete newFilters[category];
      }
      
      return newFilters;
    });
  };
  
  // Clear all filters
  const handleClearFilters = () => {
    setActiveFilters({});
  };

  return {
    filterCategories,
    activeFilters,
    filteredDevices,
    handleFilterChange,
    handleClearFilters
  };
};
